import axios from "axios";
import e from "express";
import useSession from "hooks/useSession";
import { TravellerInfo,Item, BookingGlobick, ActivityCard, CreateOrderGlobick } from "models/globick";
import { getLanguageTMB } from "pages/public/TmbDetailActivity/TmbDetailActivity.service";
import { postAxios } from "services/api/api.service";
import { getEndpoint } from "services/api/endpoint.service";


//Variables para globick
declare const window: any;
//  let user = "3udmootoogf0888hijt0fkhepo";
//  let password = "1b4dgr8ufke8ni81iihb813bgc182odoi308sfplphpucntovmjh";
//let user = "3sgnrer145v3ma2nf0ckkeb1sj";
//let password = "tddntrehjaojpt0qa26f0v8rmlb9dsccgmjb4oh7ordfbmrnrks";
let user="";
let password="" ;
let env=""
let url="";
let detailUser:any;
let totalTickets:any;
let tokenMock="eyJraWQiOiJKMW9QUzUwakVUdVZqTmlTUkRtR2lza2tMNFkrZTFFOXY5YWZrRlwvVlwvbkE9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIzdWRtb290b29nZjA4ODhoaWp0MGZraGVwbyIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYWN0aXZpdHlcL3dyaXRlIG9yZGVyXC93cml0ZSBwYXltZW50XC9yZWFkIG9yZGVyXC9yZWFkIHRyYW5zZmVyXC9yZWFkIHRyYW5zZmVyXC93cml0ZSBwYXltZW50XC93cml0ZSBhY3Rpdml0eVwvcmVhZCIsImF1dGhfdGltZSI6MTY5Mzk5MjAwOSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLmV1LXdlc3QtMS5hbWF6b25hd3MuY29tXC9ldS13ZXN0LTFfbk5MTGNjbmxlIiwiZXhwIjoxNjk0MDA2NDA5LCJpYXQiOjE2OTM5OTIwMDksInZlcnNpb24iOjIsImp0aSI6IjUxY2E4ZWVmLTVhOTQtNDdkZC04MzcxLThiZGMwY2UyNGYyYyIsImNsaWVudF9pZCI6IjN1ZG1vb3Rvb2dmMDg4OGhpanQwZmtoZXBvIn0.Y565_OrUEZoGsZinaBQ-IWCtKIY3c1_4r9GzVigwILmCd9LpmwiT3pS5K5AJeH3FjDaxuVTbWB-ccUARAguyhR6NrYbLu9h4fQnKT1z2qvOa-0-2pITv5sCG1_IGUmTRRdHfvatLkkZBIwpgm3SPM86QKisSjh2ykWC1cuDEqpYjxvUjykhC2Kgt4fl28TjtRAG4cqVJJ103GowlXWyLiG6uCkRJurQU26xTO5G_sf-hEtj2zeS0wEQZkZKl362XJ81uF_5Wuzt7PpkpxFv4KC5yownLz2JBd2ztPyLY0pgabKgKOKcPiLt-ykVSXq8eNz24Q-NYpm78lqULzJ-E0w"

if(window?.location?.href?.includes('https://www.docomobility.com/app/')){
  //Credenciales PRO
  user = "3sgnrer145v3ma2nf0ckkeb1sj";
  password = "tddntrehjaojpt0qa26f0v8rmlb9dsccgmjb4oh7ordfbmrnrks";
  env="prod";
  url="https://auth.recoglobick.com/oauth2/token?grant_type=client_credentials"
}else{
  //Credenciales PRE/INT
  user = "3udmootoogf0888hijt0fkhepo";
  password = "1b4dgr8ufke8ni81iihb813bgc182odoi308sfplphpucntovmjh";
  env="test";
  url="https://pre-api-activities.recoglobick.com/token?grant_type=client_credentials"
}

export function globick(tripSelectedDetails: any, getUserDetail: any,setBookingGlobick:any,setActivityGlobick:any,token:string,localidad:any) {
  setActivityGlobick(null)
  setBookingGlobick(null)
  detailUser = getUserDetail;
  totalTickets=tripSelectedDetails.body.travellers.length
  window.RecoglobickActivitiesWidget?.mount({
    env: env, // test
    token: `Bearer ${token}`, // token de la api ,falta
    clientBookingId: detailUser?.customerId,
    startDate:tripSelectedDetails?.body?.outwardJourney?.trip?.Origin?.date.toString(),
    //endDate:tripSelectedDetails?.body?.outwardJourney?.trip?.Destination?.date.toString(),
    //location: mapLocality(tripSelectedDetails?.body?.outwardJourney?.trip?.Destination?.name),
    location:localidad, //Mock de localidad a falta de mapeo de localidades
    totalTickets:totalTickets,
    language: sessionStorage.getItem("raas-language")? getLanguageTMB(sessionStorage.getItem("raas-language")): "es-ES",
    currency: "EUR",
    travellers: passengerMapping(tripSelectedDetails, getUserDetail),
    postOrderCallback: (e:void)=> reservedActivityCallback(e,setBookingGlobick,setActivityGlobick,localidad),
    expiredTokenCallback: (...data: any) => console.log("expiredTokenCallback",data)
 
  });
 
}



export function globickMMB(token:string,idBooking:string, lenguage:string) {
  //getTokenGlobick()
  window.RecoglobickActivitiesMmbWidget?.mount({
    env: env, // test
    token: `Bearer ${token}`, // token de la api ,falta
    bookingId: idBooking, // Es el clientBookingId que se asignó en actividades. (Obligatorio)
    language:formatLenguage(lenguage),
    expiredTokenCallback: (...data: any) => console.log("expiredTokenCallback",data),
    cancelOrderCallback: (e:void)=> console.log("cancelOrderCallback",e)
  });
}

export function formatLenguage(lenguage:string) {
  let result
  switch (lenguage) {
    case 'es':
      result="es-ES"
      break;
    case 'en':
      result="us-EN"
    break;
  
    default:
            result="es-ES"
      break;
  }
return result
}



//Funcion para mapear los pasajeros, TO-DO controlar caso de AVE
export function passengerMapping(tripSelectedDetails: any,getUserDetail: any): TravellerInfo[] {
  const detailUser = getUserDetail;
  //la primera posicion es para los datos del contacto, el resto es para los viajeros seleccionados
  let numPassenger = tripSelectedDetails.body.travellers.length + 1;
  let apellido1=detailUser?.customerFullName?.firstSurname +" "
  let apellido2=detailUser?.customerFullName?.secondSurname!==null ? detailUser?.customerFullName?.secondSurname : ''
  let result: TravellerInfo[] = [];
  for (let index = 0; index < numPassenger; index++) {
    const aux = {
      name: detailUser?.customerFullName?.name,
      surname:apellido1+apellido2,
      email: detailUser?.email,
      countryPhoneCode: detailUser?.phone.prefix,
      phone: detailUser?.phone.number,
    };
    result.push(aux);
  }
  return result;
}

/**
 * Calback para obtener los datos de la actividad
 * @param response 
 */
export function reservedActivityCallback(response: any,setBookingGlobick:any,setActivityGlobick:any,localidad:any) {


  let duration=response.activityDuration
  let horas=Math.floor(duration / 0x3C ) % 0x3C

  const cardActivity:ActivityCard={
    title:response.name,
    date:response.startDate.substring(0, 10),
    duration:`${horas} h`,
    tickets:totalTickets,
    price:response.price,
    startTime:response.startDate.substring(11, 16),
    imagen:response.activityImg

  }

  /*const data:any ={
    trip:{
      imageUrl: response.activityImg,
      name: response.name,
      location: localidad,
      activityDate: (response.startDate.replace(/ /g, "T"))+"Z",
      description: response?.activityTranslations?.description,
      include: response?.activityTranslations?.include,
      importantInfo: response?.activityTranslations?.specialNotes,
      cancellationPolicy: response?.activityTranslations?.cancellationPolicy,
      clientSession: response?.clientSession
    },
   // activityDate:(response.startDate.replace(/ /g, "T"))+"Z",
    activityId:response.activityId,
    //clientSession:response.clientSession,
    sessionId:response?.activitySessionId, 
    contactEmail: detailUser.email,
    contactName: detailUser.customerFullName.name,
    requestedTickets:response.selectedTickets.map((t: any) => {return {rateId: t.rateId,quantity: t.quantity}}),
    paxInfo:[
      {
        email: detailUser?.email,
        lastName: detailUser?.customerFullName?.firstSurname,
        phone: detailUser?.phone?.number,
        name: detailUser?.customerFullName?.name,
      }
    ]
  }*/
  const data:any ={
    trip: {
      imageUrl: response.activityImg,
      name: response.name,
      location: localidad,
      activityDate: (response.startDate.replace(/ /g, "T"))+"Z",
      description: response?.activityTranslations?.description,
      include: response?.activityTranslations?.includes,
      importantInfo: response?.activityTranslations?.specialNotes,
      cancellationPolicy: response?.activityTranslations?.cancellationPolicy,
      clientSession:response?.clientSession
  },
  bookingId: response?.bookingId, 
  activitySessionId: response?.activitySessionId, 
  clientSession:response?.clientSession
  }
  console.log("RETURN",data)
  setActivityGlobick(cardActivity)
  setBookingGlobick(data)

  window.RecoglobickActivitiesWidget.unmount();

}


const headers = {
  headers: {
    "Authorization": "Basic " + btoa(user + ":" + password),
    "Content-type": "application/x-www-form-urlencoded",
    Origin: "https://pre-qa.recoglobick.com"
  },
};

/*export async function getTokenGlobick() {
 
let fetchURL="https://pre-api-activities.recoglobick.com/token?grant_type=client_credentials"
  const response = await fetch(fetchURL, {
    method: 'POST',
    headers: {
    "Authorization": "Basic " + btoa(user + ":" + password),
    "Content-type": "application/x-www-form-urlencoded",
    "Origin": "https://pre-qa.recoglobick.com"

      
    }
  })
  return response;
}*/



/**
 * Funcion para obtener el token de globick
 * @param mock token moqueado
 * @returns 
 */
export async function postGlobick(mock:string) {
  if (mock === "true") {
    return tokenMock

  }else{
    return new Promise((resolve, reject) => {
      return axios.post(url,null,headers)
          .then((response) => {
              if(response.status !== 204) response.data.status = response.status;
              resolve(response.data.access_token);
          })
          .catch((error) => {
              reject(error.response);
          });
  })
  }
}

export function getTokenGlobickCallPromise(mock: any) {
  return postGlobick(mock)
}

export async function getTokenGlobick(mock: any, callback: Function, errorCallback: Function) {
  await Promise.all
      return getTokenGlobickCallPromise(mock)
      .then((data: any) => {
          callback(data);
      })
      .catch((error: any) => {
          errorCallback(error)
      })
    }

    export async function getAddressFromCoordinates(latitude: any, longitude: any,callback: Function, errorCallback: Function) {
      await Promise.all
          return getAddressFromCoordinatesCallPromise(latitude, longitude)
          .then((data: any) => {
            callback(data);
          })
          .catch((error: any) => {
            errorCallback(error)
        })
        }    
  export function getAddressFromCoordinatesCallPromise(latitude: any, longitude: any) {
          return getLocalidad(latitude, longitude)
  }

        export async function getLocalidad(latitude: any, longitude: any) {
          //let key="TwewIDYj_tHDmrfrI_5SCIDOikJ0tbojI4iQcbwSN-Y"
            return new Promise((resolve, reject) => {
              //return axios.get(`https://revgeocode.search.hereapi.com/v1/revgeocode?at=${latitude},${longitude}&lang=en-US&apiKey=${key}`)
               return axios.get(`https://nominatim.openstreetmap.org/reverse?format=geojson&lat=${latitude}&lon=${longitude}`)
                  .then((response) => {
                    
                    const features=response?.data?.features[0]?.properties?.address
                      //resolve(response.data.items[0].address.county);
                      resolve(removeAccents(features.province || features.city))
                  })
                  .catch((error) => {
                      reject(error.response);
                  });
          })
        }      

function removeAccents(str:string) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
